import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const proformaIssueFormsGeneralRoute: InvariantJiraRoute = {
	name: 'proforma-issue-forms-general',
	path: '/jira/forms/create',
	exact: true,
};
